import { gql } from '@apollo/client'
import fragments from 'graphql/fragments'

export const GET_MODELLING_PROJECTS = gql`
  query ModellingProjects($baseProjectId: ID!, $userId: String!) {
    modellingProjects(baseProjectId: $baseProjectId, userId: $userId) {
      id
      name
      type
      createdDate
    }
  }
`

export const GET_MODELLING_PROJECTS_FULL = gql`
  query ModellingProjects($baseProjectId: ID!, $userId: String!) {
    modellingProjects(baseProjectId: $baseProjectId, userId: $userId) {
      ...ModellingProject
    }
  }
  ${fragments.modellingProject}
`

export const GET_MODELLING_PROJECT = gql`
  query ModellingProject($modellingProjectId: ID!) {
    modellingProject(modellingProjectId: $modellingProjectId) {
      ...ModellingProject
    }
  }
  ${fragments.modellingProject}
`

export const ADD_MODELLING_PROJECT = gql`
  mutation AddModellingProject(
    $userId: String!
    $name: String!
    $baseProjectId: ID!
    $type: ModellingProjectType!
  ) {
    addModellingProject(userId: $userId, name: $name, baseProjectId: $baseProjectId, type: $type) {
      ...ModellingProject
    }
  }
  ${fragments.modellingProject}
`

export const SAVE_MODELLING_PROJECT = gql`
  mutation SaveModellingProject($projectId: ID!, $name: String!) {
    saveModellingProject(projectId: $projectId, name: $name) {
      ...ModellingProject
    }
  }
  ${fragments.modellingProject}
`

export const DELETE_MODELLING_PROJECT = gql`
  mutation DeleteModellingProject($modellingProjectId: ID!) {
    deleteModellingProject(modellingProjectId: $modellingProjectId)
  }
`

export const HAS_ANY_MODELLING_PROJECTS = gql`
  query HasAnyModellingProjects($baseProjectId: ID!) {
    hasAnyModellingProjects(baseProjectId: $baseProjectId)
  }
`

export const IS_USED_IN_MODELLING_PROJECTS = gql`
  query UsedInAnyModellingProjects($investorId: ID!) {
    usedInAnyModellingProjects(investorId: $investorId)
  }
`

const mutations = {
  addRemote: ADD_MODELLING_PROJECT,
  saveRemote: SAVE_MODELLING_PROJECT,
  deleteRemote: DELETE_MODELLING_PROJECT,
  saveOp: 'saveModellingProject',
  addOp: 'addModellingProject',
  deleteOp: 'deleteModellingProjectCascade',
}

export const modellingProjectsQueries = { ...mutations, getRemote: GET_MODELLING_PROJECTS }
